<template>
    <div class="form-group flex items-center" id="thermostat-widget-form">
        <div class="maxwidth thermostatwidgetrow">

            <div class="text-center">
                <div class="flex justify-around">
                    <h3 class="mr-4">
                        Existing Thermostat Setbacks
                    </h3>
                    <h3 class="ml-4">
                        Proposed Thermostat Setbacks
                    </h3>
                </div>
                <div class="flex justify-around">
                    <div class="flex flex-col w-third">
                        <form-text
                            field-name="existing_degree_setback_heating"
                            label="Heating Setback Degrees"
                            v-model="existing_degree_setback_heating"
                        ></form-text>
                        <form-text
                            field-name="existing_degree_setback_cooling"
                            label="Cooling Setback Degrees"
                            v-model="existing_degree_setback_cooling"
                        ></form-text>
                    </div>
                    <div class="flex flex-col w-third">
                        <form-text
                            field-name="proposed_degree_setback_heating"
                            label="Heating Setback Degrees"
                            v-model="proposed_degree_setback_heating"
                        ></form-text>
                        <form-text
                            field-name="proposed_degree_setback_cooling"
                            label="Cooling Setback Degrees"
                            v-model="proposed_degree_setback_cooling"
                        ></form-text>
                    </div>
                </div>
            </div>

            <div class="w-full text-right pr-4 pt-4">
                <button class="button" @click="$emit('close-modal')">Save</button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        inject: {
            form: {
                default() {
                    return {
                        disabled: false,
                        errors: new FormErrors()
                    }
                }
            },
            apiClient: {
                default() {
                    return axios;
                }
            }
        },

        /** Hard code for now, use something dynamic later **/
        computed: {
            existing_degree_setback_heating: {
                get() {
                    return this.form.data.existing_degree_setback_heating;
                },
                set(newDegreeSetback) {
                    this.form.data.existing_degree_setback_heating = newDegreeSetback;
                },
            },
            existing_degree_setback_cooling: {
                get() {
                    return this.form.data.existing_degree_setback_cooling;
                },
                set(newDegreeSetback) {
                    this.form.data.existing_degree_setback_cooling = newDegreeSetback;
                }
            },
            proposed_degree_setback_heating: {
                get() {
                    return this.form.data.proposed_degree_setback_heating;
                },
                set(newDegreeSetback) {
                    this.form.data.proposed_degree_setback_heating = newDegreeSetback;
                },
            },
            proposed_degree_setback_cooling: {
                get() {
                    return this.form.data.proposed_degree_setback_cooling;
                },
                set(newDegreeSetback) {
                    this.form.data.proposed_degree_setback_cooling = newDegreeSetback;
                }
            }
        }
    }
</script>
